<script>
import Layout from '@layouts/main'

export default {
  name: 'Loading',
  components: { Layout },
}
</script>

<template>
  <Layout>
    <v-content>
      <v-container
        fluid
        fill-height>
        <v-layout
          align-center
          justify-center>
          <v-flex
            xs12
            sm8
            md4>
            <v-progress-circular
              :size="50"
              indeterminate
              color="primary"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.loadingIcon {
  @extend %typography-xxlarge;

  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
</style>
